import { SvgIcon } from '@mui/material'

export default function IDVerifiedIcon() {
  return (
    <SvgIcon sx={{ width: 16, height: 16 }}>
      <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <title>ID Verified</title>
        <path
          d='M7.46 0.906748L2.79333 2.98008C2.31333 3.19341 2 3.67341 2 4.20008V7.33342C2 11.0334 4.56 14.4934 8 15.3334C11.44 14.4934 14 11.0334 14 7.33342V4.20008C14 3.67341 13.6867 3.19341 13.2067 2.98008L8.54 0.906748C8.2 0.753415 7.8 0.753415 7.46 0.906748ZM6.19333 10.8601L4.46667 9.13342C4.20667 8.87341 4.20667 8.45341 4.46667 8.19341C4.72667 7.93341 5.14667 7.93341 5.40667 8.19341L6.66667 9.44675L10.5867 5.52675C10.8467 5.26675 11.2667 5.26675 11.5267 5.52675C11.7867 5.78675 11.7867 6.20675 11.5267 6.46675L7.13333 10.8601C6.88 11.1201 6.45333 11.1201 6.19333 10.8601Z'
          fill='#388E10'
        />
      </svg>
    </SvgIcon>
  )
}
